/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LogTarget } from '../model';
/**
 * LogApi - axios parameter creator
 * @export
 */
export const LogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LogTarget} logTarget 
         * @param {boolean} [reverse] 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {string} [filter] 
         * @param {string} [since] 
         * @param {string} [until] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logControllerGetLogLines: async (logTarget: LogTarget, reverse?: boolean, firstResult?: number, maxResults?: number, filter?: string, since?: string, until?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logTarget' is not null or undefined
            assertParamExists('logControllerGetLogLines', 'logTarget', logTarget)
            const localVarPath = `/api/log/getLogLines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (logTarget !== undefined) {
                localVarQueryParameter['logTarget'] = logTarget;
            }

            if (reverse !== undefined) {
                localVarQueryParameter['reverse'] = reverse;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = until;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LogTarget} logTarget 
         * @param {string} [filter] 
         * @param {string} [since] 
         * @param {string} [until] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logControllerGetLogLinesCount: async (logTarget: LogTarget, filter?: string, since?: string, until?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logTarget' is not null or undefined
            assertParamExists('logControllerGetLogLinesCount', 'logTarget', logTarget)
            const localVarPath = `/api/log/getLogLinesCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (logTarget !== undefined) {
                localVarQueryParameter['logTarget'] = logTarget;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = until;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogApi - functional programming interface
 * @export
 */
export const LogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LogTarget} logTarget 
         * @param {boolean} [reverse] 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {string} [filter] 
         * @param {string} [since] 
         * @param {string} [until] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logControllerGetLogLines(logTarget: LogTarget, reverse?: boolean, firstResult?: number, maxResults?: number, filter?: string, since?: string, until?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logControllerGetLogLines(logTarget, reverse, firstResult, maxResults, filter, since, until, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogApi.logControllerGetLogLines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LogTarget} logTarget 
         * @param {string} [filter] 
         * @param {string} [since] 
         * @param {string} [until] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logControllerGetLogLinesCount(logTarget: LogTarget, filter?: string, since?: string, until?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logControllerGetLogLinesCount(logTarget, filter, since, until, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogApi.logControllerGetLogLinesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogApi - factory interface
 * @export
 */
export const LogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogApiFp(configuration)
    return {
        /**
         * 
         * @param {LogTarget} logTarget 
         * @param {boolean} [reverse] 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {string} [filter] 
         * @param {string} [since] 
         * @param {string} [until] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logControllerGetLogLines(logTarget: LogTarget, reverse?: boolean, firstResult?: number, maxResults?: number, filter?: string, since?: string, until?: string, options?: any): AxiosPromise<string> {
            return localVarFp.logControllerGetLogLines(logTarget, reverse, firstResult, maxResults, filter, since, until, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LogTarget} logTarget 
         * @param {string} [filter] 
         * @param {string} [since] 
         * @param {string} [until] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logControllerGetLogLinesCount(logTarget: LogTarget, filter?: string, since?: string, until?: string, options?: any): AxiosPromise<number> {
            return localVarFp.logControllerGetLogLinesCount(logTarget, filter, since, until, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LogApi - object-oriented interface
 * @export
 * @class LogApi
 * @extends {BaseAPI}
 */
export class LogApi extends BaseAPI {
    /**
     * 
     * @param {LogTarget} logTarget 
     * @param {boolean} [reverse] 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {string} [filter] 
     * @param {string} [since] 
     * @param {string} [until] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogApi
     */
    public logControllerGetLogLines(logTarget: LogTarget, reverse?: boolean, firstResult?: number, maxResults?: number, filter?: string, since?: string, until?: string, options?: RawAxiosRequestConfig) {
        return LogApiFp(this.configuration).logControllerGetLogLines(logTarget, reverse, firstResult, maxResults, filter, since, until, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LogTarget} logTarget 
     * @param {string} [filter] 
     * @param {string} [since] 
     * @param {string} [until] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogApi
     */
    public logControllerGetLogLinesCount(logTarget: LogTarget, filter?: string, since?: string, until?: string, options?: RawAxiosRequestConfig) {
        return LogApiFp(this.configuration).logControllerGetLogLinesCount(logTarget, filter, since, until, options).then((request) => request(this.axios, this.basePath));
    }
}

